import FormInputTypes from '../components/atoms/formEnums/formInputTypes';

export default {
  attributeName: 'appContent',
  isDragable: false,
  canOpen: false,
  canEdit: false,
  canCreate: false,
  canRemove: false,
  isSelectable: true,
  isMultiSelectable: false,
  getURL: 'appId/areaId/appContent',
  sessionParams: ['appId', 'areaId'],
  emptyMessage: "You don't have contents, visit the content section to create one.",
  fields: [
    {
      attributeName: 'name',
      label: 'Name',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: true,
      canFilter:true,
      canEdit: true,
      canCreate: true,
      canOpen: true,
      helpText: 'Name of the content.',
    },
    {
      attributeName: 'app',
      label: 'Sport room',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: true,
      canEdit: false,
      canCreate: true,
      canOpen: true,
      canFilter: true,
      helpText: 'Name of the Sport room.',
    },
    {
      attributeName: 'expired',
      label: 'Expired',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      default: '',
      canOrder: true,
      canFilter:false,
      canEdit: true,
      canCreate: false,
      canOpen: false,
      helpText: 'Name of the content.',
      exactWidth:'100px'
    },
  ],
};
